export const defaultModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '500px',
    margin: 'auto',
  },
};

export const tinyModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '300px',
    margin: 'auto',
  },
};

export const wideModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '570px',
    margin: 'auto',
  },
};

export const wideNoScrollModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '570px',
    margin: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
};

export const ultraWideModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '660px',
    margin: 'auto',
  },
};

export const ultraWideNoScrollModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '660px',
    margin: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
};

export const extraWideModalStyles = {
  content: {
    height: 'max-content',
    maxWidth: '712px',
    margin: 'auto',
  },
};
